import { ReactComponent as Icon1Blue } from "../Images/icon_circleNum_1_blue.svg";
import { ReactComponent as Icon1Border } from "../Images/icon_circleNum_1_blueBorder.svg";

import { ReactComponent as Icon2Gray } from "../Images/icon_circleNum_2_gray.svg";
import { ReactComponent as Icon2Blue } from "../Images/icon_circleNum_2_blue.svg";
import { ReactComponent as Icon2Border } from "../Images/icon_circleNum_2_blueBorder.svg";

import { ReactComponent as Icon3Gray } from "../Images/icon_circleNum_3_gray.svg";
import { ReactComponent as Icon3Blue } from "../Images/icon_circleNum_3_blue.svg";
import { ReactComponent as Icon3Border } from "../Images/icon_circleNum_3_blueBorder.svg";

import { ReactComponent as Icon4Gray } from "../Images/icon_circleNum_4_gray.svg";
import { ReactComponent as Icon4Blue } from "../Images/icon_circleNum_4_blue.svg";

import styled from "styled-components";

const ProgressBar = ({ step }) => {
  return (
    <Layout>
      {step === 1 ? <Icon1Blue /> : <Icon1Border />}
      <BlueDashLine $active={step > 1} />
      {step === 2 ? <Icon2Blue /> : step > 2 ? <Icon2Border /> : <Icon2Gray />}
      <BlueDashLine $active={step > 2} />
      {step === 3 ? <Icon3Blue /> : step > 3 ? <Icon3Border /> : <Icon3Gray />}
      <BlueDashLine $active={step > 3} />
      {step === 4 ? <Icon4Blue /> : <Icon4Gray />}
    </Layout>
  );
};

export default ProgressBar;

const Layout = styled.div`
  display: inline-flex;
  gap: 0;
`;

const BlueDashLine = styled.div`
  width: 48px;
  border-top: ${(props) =>
    props.$active ? "1px dashed #1167ED" : "1px dashed #b0b0b0"};
  margin-top: 16px;
`;
